module.exports = __webpack_public_path__ + "static/img/banner-fixed3.44bed84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-fixed3.jpg
// module id = XI7A
// module chunks = 1